import { ReactElement } from 'react'

export type IconNames = 'packingBox' | 'envelope'

export interface IconProps {
  icon: IconNames // Ensures the key matches one of the icon names
  width?: number
  height?: number
  color?: string
  className?: string
  stroke?: string
  strokeWidth?: string
  onClick?: () => void
}

// Icon collection with multiple SVG icons stored as key-value pairs
export const icons: Record<
  IconNames,
  (props: Partial<IconProps>) => ReactElement
> = {
  packingBox: ({
    width = 18,
    height = 18,
    color = 'fill-primary',
    className,
  }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18 18"
      className={className} // Make sure this is passed
      fill="currentColor" // Ensures className controls the fill
    >
      <path
        d="M7.7319 0.253303C8.54515 -0.0844342 9.45485 -0.0844342 10.2681 0.253303L17.0163 3.05579C17.307 3.17639 17.5559 3.38312 17.7311 3.64952C17.9064 3.91591 18 4.22983 18 4.55106V13.4489C18 13.7702 17.9064 14.0841 17.7311 14.3505C17.5559 14.6169 17.307 14.8236 17.0163 14.9442L10.2681 17.7467C9.45485 18.0844 8.54515 18.0844 7.7319 17.7467L0.9837 14.9442C0.693029 14.8236 0.444126 14.6169 0.268873 14.3505C0.0936202 14.0841 -1.82297e-06 13.7702 0 13.4489V4.55198C-1.82297e-06 4.23075 0.0936202 3.91683 0.268873 3.65044C0.444126 3.38404 0.693029 3.17731 0.9837 3.05671L7.7319 0.254224V0.253303ZM9.7605 1.5347C9.27276 1.33226 8.72724 1.33226 8.2395 1.5347L6.5169 2.25007L13.2912 4.94838L15.6933 3.99886L9.7605 1.5347ZM11.4219 5.68772L4.6935 3.00693L2.331 3.9878L9.0009 6.64462L11.4219 5.68772ZM1.35 13.4499C1.35012 13.4956 1.36353 13.5403 1.38854 13.5782C1.41354 13.6162 1.449 13.6456 1.4904 13.6628L8.2395 16.4653C8.2674 16.4773 8.2962 16.4883 8.325 16.4985V7.85965L1.35 5.08113V13.4499ZM9.7605 16.4653L16.5096 13.6628C16.5511 13.6456 16.5867 13.616 16.6117 13.5779C16.6367 13.5398 16.6501 13.4949 16.65 13.4489V5.10234L9.675 7.86057V16.4985C9.7038 16.4883 9.7326 16.4773 9.7605 16.4653Z"
        fill={color}
      />
    </svg>
  ),
  envelope: ({
    width = 18,
    height = 18,
    className, // Ensure Tailwind classes control styles
  }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      className={className} // Allows Tailwind to style it
      fill="none" // Avoids unexpected default fills
      stroke="currentColor" // Enables Tailwind stroke colors
    >
      <path
        d="M3.33268 3.33594H16.666C17.5827 3.33594 18.3327 4.08594 18.3327 5.0026V15.0026C18.3327 15.9193 17.5827 16.6693 16.666 16.6693H3.33268C2.41602 16.6693 1.66602 15.9193 1.66602 15.0026V5.0026C1.66602 4.08594 2.41602 3.33594 3.33268 3.33594Z"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3327 5L9.99935 10.8333L1.66602 5"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
}
